import { useCallback } from 'react'

// Types are declared in src/types/app-bridge.d.ts

/**
 * Hook to handle Shopify authentication via App Bridge v4
 *
 * App Bridge v4 automatically:
 * 1. Creates a global `shopify` object when loaded in Shopify Admin
 * 2. Injects session tokens into fetch requests for the app's domain
 *
 * We use Vercel's rewrite rules to proxy /api/* requests to Railway,
 * so App Bridge treats them as same-origin and auto-injects tokens.
 */
export function useShopifyAuth() {
  const isInShopifyAdmin = !!window.shopify

  console.log('[useShopifyAuth] isInShopifyAdmin:', isInShopifyAdmin)
  if (window.shopify) {
    console.log('[useShopifyAuth] config:', window.shopify.config)
    console.log('[useShopifyAuth] environment:', window.shopify.environment)
  }

  // Get shop info from App Bridge
  const getShopInfo = useCallback(() => {
    if (!window.shopify) {
      return null
    }
    return {
      shop: window.shopify.config.shop,
      host: window.shopify.config.host,
    }
  }, [])

  return {
    getShopInfo,
    isInShopifyAdmin,
  }
}

export default useShopifyAuth
